import React from "react";
import { useDispatch } from "react-redux";
import { Button, Divider, Grid, Header, Icon, List, Segment } from "semantic-ui-react";
import { useMediaQuery } from "react-responsive";
import { closeModal } from "../../../app/common/modals/modalSlice";
import ModalWrapper from "../../../app/common/modals/modalWrapper";

export default function DualAgentProgressModal({ steps, isComplete }) {
  const dispatch = useDispatch();
  const isMobile = useMediaQuery({ query: "(max-width:768px)" });

  function handleClose() {
    dispatch(
      closeModal({
        modalType: "DualAgentProgressModal",
      })
    );
  }

  const getStepIcon = (status) => {
    if (status === "success") {
      return <Icon name="check circle" color="green" size="large" />;
    } else if (status === "error") {
      return <Icon name="times circle" color="red" size="large" />;
    } else if (status === "loading") {
      return <Icon name="circle notch" loading color="blue" size="large" />;
    } else {
      return <Icon name="circle outline" color="grey" size="large" />;
    }
  };

  return (
    <ModalWrapper size="small">
      <Segment>
        <Grid>
          <Grid.Column width={16}>
            <Header as="h2" color="blue">
              {isComplete ? "Transaction Linking Complete" : "Linking Transactions..."}
            </Header>
            <Divider />
            
            <List divided relaxed size="large">
              {steps.map((step, index) => (
                <List.Item key={index}>
                  <List.Content floated="right">
                    {getStepIcon(step.status)}
                  </List.Content>
                  <List.Content>
                    <List.Header style={{ paddingTop: "5px" }}>
                      {step.label}
                    </List.Header>
                    {step.error && (
                      <List.Description style={{ color: "red", marginTop: "5px" }}>
                        Error: {step.error}
                      </List.Description>
                    )}
                  </List.Content>
                </List.Item>
              ))}
            </List>

            <Divider />
            
            <Button
              disabled={!isComplete}
              onClick={handleClose}
              type="button"
              floated={isMobile ? null : "right"}
              color="blue"
              content="Close"
              className={isMobile ? "fluid" : null}
            />
          </Grid.Column>
        </Grid>
      </Segment>
    </ModalWrapper>
  );
}

